<template>
  <div class="page-content">
    <div class="table-operations">
      <el-button type="primary" size="mini" @click="handleAdd"> <i class="el-icon-plus"></i> 新增 </el-button>
      <el-button type="danger" size="mini" :disabled="!selectedRows.length" @click="handleBatchDelete">
        <i class="el-icon-delete"></i> 批量删除
      </el-button>
    </div>

    <el-table
      :data="tableData"
      @selection-change="handleSelectionChange"
      style="margin: 20px 10px; width: calc(100% - 20px)"
      height="calc(100% - 60px)"
    >
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
      <el-table-column prop="roleName" label="角色名称" width="120" align="center"> </el-table-column>
      <el-table-column prop="roleCode" label="角色编码" width="120" align="center"> </el-table-column>
      <el-table-column prop="comments" label="备注" align="center"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" align="center"> </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="180" align="center"> </el-table-column>
      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleSetPermissions(scope.row)"> 配置权限 </el-button>
          <el-button type="text" size="small" @click="handleEdit(scope.row)"> 编辑 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="form.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="comments">
          <el-input type="textarea" v-model="form.comments" placeholder="请输入备注信息"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 权限配置弹窗 -->
    <el-dialog title="配置权限" :visible.sync="permissionDialogVisible" width="600px" class="permission-dialog">
      <div class="permission-tree">
        <el-checkbox v-model="checkAll" @change="handleCheckAllChange">选择全部</el-checkbox>
        <div class="menu-list">
          <el-card class="menu-card">
            <div slot="header" class="card-header">
              <span>权限菜单</span>
            </div>
            <div class="tree-container">
              <el-tree
                :data="permissionList"
                :props="defaultProps"
                show-checkbox
                node-key="id"
                ref="mainTree"
                :default-expand-all="true"
                @check="handleMainTreeCheck"
              >
              </el-tree>
            </div>
          </el-card>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePermissionSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';
export default {
  name: 'RolesManagement',
  data() {
    return {
      tableData: [],
      selectedRows: [],
      dialogVisible: false,
      dialogTitle: '新增角色',
      form: {
        roleName: '',
        comments: '',
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        comments: [{ required: false, message: '请输入备注信息', trigger: 'blur' }],
      },
      // 权限配置相关数据
      permissionDialogVisible: false,
      permissionList: [],
      checkedKeys: [],
      currentRole: null,
      checkAll: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.post(baseUrl + '/api/system/role/list').then((res) => {
        console.log(res);

        this.tableData = res.data;
      });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleAdd() {
      this.dialogTitle = '新增角色';
      this.form = {
        roleName: '',
        comments: '',
      };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogTitle = '编辑角色';
      this.form = {
        roleName: row.roleName,
        comments: row.comments,
        roleId: row.roleId,
      };
      this.dialogVisible = true;
    },
    handleBatchDelete() {
      this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个角色?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // TODO: 调用批量删除接口
          axios
            .post(
              baseUrl + '/api/system/role/removeBatch',
              this.selectedRows.map((row) => row.roleId)
            )
            .then((res) => {
              this.$message.success('删除成功');
              this.fetchData();
            });
          this.$message.success('删除成功');
        })
        .catch(() => {});
    },
    handleSetPermissions(row) {
      this.currentRole = row;
      this.fetchPermissionList();
      this.permissionDialogVisible = true;
    },
    fetchPermissionList() {
      axios
        .post(baseUrl + '/api/sys/menu/authority/list', {
          roleId: this.currentRole.roleId,
        })
        .then((res) => {
          this.permissionList = res.data;
          console.log('获取的权限', res);

          // 初始化树的选中状态
          this.$nextTick(() => {
            const mainTree = this.$refs.mainTree;
            if (mainTree) {
              // 递归设置树节点的选中状态
              this.setTreeCheckedStatus(this.permissionList, mainTree);
            }
          });

          // 更新全选状态
          this.updateCheckAllStatus();
        });
    },

    // 递归设置树节点的选中状态
    setTreeCheckedStatus(nodes, tree) {
      nodes.forEach((node) => {
        if (node.checked) {
          tree.setChecked(node.id, true, false);
        }
        // 递归处理子节点
        if (node.children && node.children.length > 0) {
          this.setTreeCheckedStatus(node.children, tree);
        }
      });
    },

    // 递归收集所有选中的节点ID
    collectCheckedIds(nodes) {
      const checkedIds = [];
      nodes.forEach((node) => {
        if (node.checked) {
          checkedIds.push(node.id);
        }
        // 递归收集子节点的选中ID
        if (node.children && node.children.length > 0) {
          checkedIds.push(...this.collectCheckedIds(node.children));
        }
      });
      return checkedIds;
    },
    handleCheckAllChange() {
      const checked = this.checkAll;
      // 更新主树的选中状态
      const mainTree = this.$refs.mainTree;
      if (mainTree) {
        if (checked) {
          // 选中所有节点
          this.setAllNodesChecked(this.permissionList, mainTree);
        } else {
          // 取消选中所有节点
          mainTree.setCheckedKeys([]);
        }
      }
    },

    // 递归设置所有节点为选中状态
    setAllNodesChecked(nodes, tree) {
      nodes.forEach((node) => {
        tree.setChecked(node.id, true, false);
        if (node.children && node.children.length > 0) {
          this.setAllNodesChecked(node.children, tree);
        }
      });
    },
    handleMainTreeCheck(data, checked) {
      // 更新全选状态
      this.updateCheckAllStatus();
    },
    handlePermissionSubmit() {
      // 收集所有选中的权限ID
      const checkedIds = new Set();

      // 从主树获取所有选中的节点ID
      const mainTree = this.$refs.mainTree;
      if (mainTree) {
        const checkedKeys = mainTree.getCheckedKeys();
        checkedKeys.forEach((id) => checkedIds.add(id));

        // 为每个选中的节点添加其所有父级（祖父级等）节点
        checkedKeys.forEach((checkedId) => {
          const parentIds = this.getParentIdsPath(this.permissionList, checkedId);
          parentIds.forEach((parentId) => checkedIds.add(parentId));
        });
      }

      // 提交保存
      axios
        .post(baseUrl + '/api/sys/menu/authority/save', {
          roleId: this.currentRole.roleId,
          authorityList: Array.from(checkedIds),
        })
        .then((res) => {
          this.$message.success('权限配置成功');
          this.permissionDialogVisible = false;
          this.fetchData(); // 刷新角色列表
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 返回从根到目标节点的所有父级ID（不含自身）
    getParentIdsPath(nodes, targetId, path = []) {
      for (let node of nodes) {
        if (node.id === targetId) {
          return path;
        }
        if (node.children && node.children.length > 0) {
          const found = this.getParentIdsPath(node.children, targetId, [...path, node.id]);
          if (found.length) {
            return found;
          }
        }
      }
      return [];
    },

    // 检查节点及其子节点中是否包含指定ID
    hasChildWithId(node, targetId) {
      if (node.id === targetId) {
        return true;
      }
      if (node.children && node.children.length > 0) {
        return node.children.some((child) => this.hasChildWithId(child, targetId));
      }
      return false;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const isEdit = !!this.form.roleId;
          const url = baseUrl + (isEdit ? '/api/system/role/update' : '/api/system/role/add');

          axios.post(url, this.form).then((res) => {
            this.$message.success(isEdit ? '编辑成功' : '新增成功');
            this.dialogVisible = false;
            this.fetchData();
          });
        }
      });
    },
    updateCheckAllStatus() {
      // 检查所有节点是否都被选中
      const mainTree = this.$refs.mainTree;
      if (mainTree) {
        const checkedNodes = mainTree.getCheckedNodes();
        const allNodes = this.getAllNodes(this.permissionList);
        this.checkAll = checkedNodes.length === allNodes.length;
      }
    },

    // 递归获取所有节点
    getAllNodes(nodes) {
      let allNodes = [];
      nodes.forEach((node) => {
        allNodes.push(node);
        if (node.children && node.children.length > 0) {
          allNodes.push(...this.getAllNodes(node.children));
        }
      });
      return allNodes;
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  height: 70vh;
}

.permission-dialog {
  :deep(.el-dialog) {
    margin-top: 15vh !important;

    .el-dialog__body {
      height: 50vh;
      padding: 10px 20px;
    }
  }
}

.permission-tree {
  height: 100%;
  overflow-y: auto;

  .el-checkbox {
    margin-bottom: 15px;
  }

  .menu-list {
    .menu-card {
      margin-bottom: 15px;

      .card-header {
        padding: 0;
        border-bottom: none;
      }

      :deep(.el-card__header) {
        padding: 10px 15px;
      }

      :deep(.el-card__body) {
        padding: 10px 15px;
      }

      .tree-container {
        margin-top: 10px;

        .el-tree {
          background: none;

          :deep(.el-tree-node__content) {
            height: 32px;
            line-height: 32px;
          }

          :deep(.el-tree-node__label) {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
